import axios from "axios";
import { useEffect, useState } from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import DcAdminNav from "./components/DcAdminNav";
import DcFooter from "./components/DcFooter";
import DcNav from "./components/DcNav";
import HomeModal from "./components/HomeModal";
import Application from "./pages/Application";
import DashBoard from "./pages/DashBoard";
import Guide from "./pages/Guide";
import Home from "./pages/Home";
import Record from "./pages/Record";
import Trekking from "./pages/Trekking";
import AdminBoardManagement from "./pages/admin/BoardManagement";
import AdminEventManagement from "./pages/admin/EventManagement";
import DcAdminLogin from "./pages/admin/LoginPage";
import AdminReceptionManagement from "./pages/admin/ReceptionManagement";
// import PayTest from './pages/PayTest';
import { Helmet } from "react-helmet";
import PayComplete from "./components/PayComplete";
import TextTest from "./pages/TextTest";
import { root_url } from "./setting";
import Course from "./subpages/Course";

function App() {
  const [modalList, setModalList] = useState([]);
  const { pathname } = useLocation();

  console.log(">>>" + pathname);

  //첫 화면에서 modalList를 가져와줘야함.
  //ie의 경우, 크롬, 엣지로 유도
  useEffect(() => {
    axios({
      method: "get",
      url: `${root_url}/api/welcome/popup`,
    }).then((res) => {
      // console.log(res);
      const { data } = res;
      setModalList(data);
    });
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0); //pathname이 바뀌는 경우, 스크롤을 맨 위로 올려줌
  }, [pathname]);

  if (pathname.startsWith("/admin/login")) {
    return (
      <div className="App">
        <Helmet>
          <meta name="robots" content="noindex" />
        </Helmet>
        <DcAdminNav />
        <Route path="/admin/login" component={DcAdminLogin} />
      </div>
    );
  } else if (pathname.startsWith("/admin")) {
    // 만약 로그인이 되어있다면 admin/reception 으로, 안되어있다면 admin/login 으로 보내자
    // login 되었는지 여부 : localStorage에 accessToken이 있는지 확인
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken === null) {
      window.location.href = "/admin/login";
      return;
    }
    return (
      <div className="App">
        <Helmet>
          <meta name="robots" content="noindex" />
        </Helmet>
        <DcAdminNav />
        <Route path="/admin/reception" component={AdminReceptionManagement} />
        <Route path="/admin/board" component={AdminBoardManagement} />
        <Route path="/admin/events" component={AdminEventManagement} />
      </div>
    );
  } else {
    return (
      <div className="App">
        <DcNav />
        {/* <HomeModal modalList={[0, 0, 0, 0, 0]} /> */}
        <Route path="/guide" component={Guide} />
        <Route path="/course" component={Course} />
        <Route path="/trekking" component={Trekking} />
        <Route path="/apply" component={Application} />
        <Route path="/record" component={Record} />
        <Route path="/dashboard" component={DashBoard} />
        <Route
          path="/"
          exact
          render={() => <HomeModal modalList={modalList} />}
        />
        <Route path="/success" component={PayComplete} />
        {/* <Route path="/pay-test" component={PayTest} />
        <Route path="/form-test" component={ParticipantForm} /> */}
        <Route path="/test" component={TextTest} />
        <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/" component={DcFooter} />
        </Switch>
      </div>
    );
  }
}

export default App;
